export default __webpack_public_path__ + "static/media/projects.a63ecd15.svg";